import React, { Component } from 'react';
import background from '../../images/ios-collage.png';
import brandLogo from '../../images/brand-logo-inverse-dark.png';
import location from '../../images/location.png';
import phone from '../../images/phone.png';
import smile from '../../images/smile.png';
import { translate } from 'react-i18next';

class Signup extends Component {
  render() {
    const { t } = this.props;
    return(
      <div className="text-center">
        <div className="container-padding">
          <h2>{t('guest.signup.heading')}<img alt="IOS OFFICES" width="200px" src={brandLogo} />!</h2>
          <h4 className="text-primary">{t('guest.signup.subheading')}</h4>
          <div className="row">
            <div className="col-sm-6 col-sm-offset-3">
              <p>{t('guest.signup.body')}</p>
            </div>
          </div>
        </div>
        <img alt="" width="100%" src={background} />
        <h4>{t('guest.signup.links')}</h4>
        <div className="row">
          <div className="col-xs-8 col-xs-offset-2 col-sm-10 col-sm-offset-1">
            <div className="row">
              <div className="col-md-4">
                <a href="https://www.iosoffices.com/renta-oficinas-ubicaciones/" style={{textDecoration: "none"}} rel="noopener noreferrer" target="_blank">
                  <img alt={t('guest.signup.img_location')} className="icon-accent" src={location} />
                  <h4 className="text-primary">{t('guest.signup.link1.heading')}</h4>
                  <p>{t('guest.signup.link1.body')}</p>
                </a>
              </div>
              <div className="col-md-4">
                <a href="https://www.iosoffices.com/iosfera/" style={{textDecoration: "none"}} rel="noopener noreferrer" target="_blank">
                  <img alt={t('guest.signup.img_phone')} className="icon-accent" src={phone} />
                  <h4 className="text-primary">{t('guest.signup.link2.heading')}</h4>
                  <p>{t('guest.signup.link2.body')}</p>
                </a>
              </div>
              <div className="col-md-4">
                <a href="https://www.iosoffices.com/renta-oficinas-planes/" style={{textDecoration: "none"}} rel="noopener noreferrer" target="_blank">
                  <img alt={t('guest.signup.img_smile')} className="icon-accent" src={smile} />
                  <h4 className="text-primary">{t('guest.signup.link3.heading')}</h4>
                  <p>{t('guest.signup.link3.body')}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Signup);



// WEBPACK FOOTER //
// ./src/guest/signup/Signup.js